import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { logoutUser } from '../../store/actions/authActions';
import { useDispatch, useSelector } from 'react-redux';

export default (isPublic) => {
  const pathname = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.common);

  useEffect(() => {
    if ((user?.accessToken?.length < 1 || (!user?.accessToken && pathname?.pathname !== '/funds/available-funds')) && !isPublic) {
      dispatch(logoutUser());
      navigate('/funds/available-funds');
    } else {
    }
  }, []);

  return {};
};
